import { WaterTye } from "./types";

export const water_type_titles = ["Fresh Surface Water", "Fresh Ground water", "Brackish Ground Water"];
export const water_type_values = ["fsw", "fgw", "bgw"] as WaterTye[];
